import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import { cardButton, SanityCardButton } from './buttonRow';

export const SanityCardGridCard = z.object({
  _key: z.string(),
  icon: z
    .object({
      title: z.string().optional().nullable(),
      svg: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  eyebrow: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  description: SanityBasicText.optional().nullable(),
  buttons: z.array(SanityCardButton).optional().nullable(),
  removeCardBackground: z.boolean(),
});
export type SanityCardGridCard = z.infer<typeof SanityCardGridCard>;

export const SanityCardGrid = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('cardGrid'),
  _key: z.string(),
  theme: z.enum(['light', 'dark', 'charcoal', 'purple']),
  backgroundPattern: z.string().optional().nullable(),
  eyebrow: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  subtitle: SanityBasicText.optional().nullable(),
  titleAlignment: z.enum(['left', 'center']),
  columns: z.enum(['2', '3', '4']),
  cards: z.array(SanityCardGridCard),
  mascot: z
    .enum([
      'none',
      'peer-sides-purple-teal',
      'peer-left-purple',
      'peer-right-teal',
      'peer-right-lime',
      'peer-behind-first-card-lime',
      'peer-behind-first-card-teal',
      'peer-behind-first-card-purple',
      // Same ids as home hero — SectionMascot resolves via HERO_MASCOT_*.
      'bounce-teal-bottom-to-cta',
      'roll-purple-bottom',
    ])
    .optional()
    .nullable(),
});
export type SanityCardGrid = z.infer<typeof SanityCardGrid>;

export const cardGrid = groq`{
  _type,
  _key,
  "theme": select(theme == "dark" => "charcoal", coalesce(theme, "light")),
  'backgroundPattern': background,
  eyebrow,
  title,
  subtitle[] ${basicText},
  titleAlignment,
  columns,
  'mascot': coalesce(mascot, 'none'),
  cards[] {
    _key,
    icon-> {
      title,
      svg,
    },
    eyebrow,
    title,
    description[] ${basicText},
    buttons[] ${cardButton},
    removeCardBackground,
  },
}`;
